/**
 * How many grants the Promotions tiles count across. The grants list holds at most the 100 most
 * recent (`GET /api/promotions/grants`), so "most recent" is true only when it is full; below that
 * it is every grant there is. The tile said "the 5 most recent grants" of five grants in all
 * (module walk, 30 Oct 2026).
 */
export const GRANTS_READ_LIMIT = 100;

export function grantSampleWords(n: number): string {
  if (n === 0) return 'no grant has been made';
  if (n === 1) return 'distinct players in the one grant';
  return n >= GRANTS_READ_LIMIT
    ? `distinct players in the ${n} most recent grants`
    : `distinct players across all ${n} grants`;
}
